import className from 'classnames/bind';
import styles from './AppBadges.module.scss';
import { GooglePlayLogo, AppleAppStoreLogo, Button } from '..';

let cx = className.bind(styles);

export function AppBadges({ googleUrl, appleUrl, className, id, align, outlined=true }) {
	const classNameArray = className?.split(' ') || [];

	return (
		<>
			{(googleUrl || appleUrl) && (
				<>
					<h2 className="sr-only">Download Our App</h2>
					<div id={id} className={cx(['ns_app-badges', 'app-badges', align && `align-badges-${align}`, outlined ? 'outlined' : 'filled', ...classNameArray])}>
						{googleUrl && (
							<Button href={googleUrl} target="_blank" rel="roreferrer noopener" outlined={outlined} className={cx(['app-badge-button'])}>
								<GooglePlayLogo />
							</Button>
						)}
						{appleUrl && (
							<Button href={appleUrl} target="_blank" rel="roreferrer noopener" outlined={outlined} className={cx(['app-badge-button'])}>
								<AppleAppStoreLogo />
							</Button>
						)}
					</div>
				</>
			)}
		</>
	);
}
